interface LogoGridProps {
  logos: Array<{ src: string; alt: string }>;
}

export const LogoGrid = ({ logos = [] }: LogoGridProps) => {
  return (
    <div className="flex flex-wrap gap-8 items-center">
      {logos.map((logo, index) => {
        return (
          <div
            key={index}
            className="transition-colors duration-300 opacity-90 hover:opacity-100"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              className="h-12 w-fit object-contain"
            />
          </div>
        );
      })}
    </div>
  );
};
